export default function extractGenres(mixes, limit) {
    const genres = []
    ;(mixes || []).forEach(mix => {
        ;(mix.genre || []).forEach(genre => {
            !genres.includes(genre) && genres.push(genre)
        })
    })
    return genres.slice(0, limit)
}
